import { BriefingBlockTypeEnum } from '../../../enums/briefing-block-type.enum';

export enum TemplateOptionEnum {
    STYLES = 'STYLES',
    CONTENT_BLOCK = 'CONTENT_BLOCK',
    IMAGE = 'IMAGE',
    DATE = 'DATE',
    TITLE = 'TITLE',
    TEXT = 'TEXT',
    TABLE_OF_CONTENTS = 'TABLE_OF_CONTENTS',
    CURATED_MENTION_LIST = 'CURATED_MENTION_LIST',
    AUTOMATIC_MENTION_LIST = 'AUTOMATIC_MENTION_LIST',
    ANALYSIS = 'ANALYSIS',
    DELIVERY_OPTIONS = 'DELIVERY_OPTIONS',
    SUBJECT_LINE = 'SUBJECT_LINE',
    FROM_NAME = 'FROM_NAME',
    REPLY_TO = 'REPLY_TO',
    MAILING_LISTS = 'MAILING_LISTS',
    RECIPIENTS = 'RECIPIENTS',
    SCHEDULING = 'SCHEDULING',
    SECTION_RULES = 'SECTION_RULES',
    ONE_COLUMN_LAYOUT = 'ONE_COLUMN_LAYOUT',
    TWO_COLUMN_LAYOUT = 'TWO_COLUMN_LAYOUT',
    THREE_COLUMN_LAYOUT = 'THREE_COLUMN_LAYOUT',
    CHART = 'CHART',
    COVERAGE_CURATOR = 'COVERAGE_CURATOR',
    LINK = 'LINK',
    DIVIDER = 'DIVIDER'
}
export interface BriefingSaveTemplateOption {
    [key: string]: boolean;
};

export const briefingTemplateContentNodes: Map<TemplateOptionEnum, TemplateOptionEnum[]>  = new Map([
    [TemplateOptionEnum.STYLES, []],
    [TemplateOptionEnum.CONTENT_BLOCK,
        []
    ],
    [TemplateOptionEnum.DELIVERY_OPTIONS,
        [
            TemplateOptionEnum.SUBJECT_LINE,
            TemplateOptionEnum.FROM_NAME,
            TemplateOptionEnum.REPLY_TO,
            TemplateOptionEnum.MAILING_LISTS,
            TemplateOptionEnum.RECIPIENTS,
            TemplateOptionEnum.SCHEDULING,
        ]
    ],
    [TemplateOptionEnum.SECTION_RULES, []],

]);

export const briefingBlockTypeToTemplateContentOptionMap: Map<BriefingBlockTypeEnum, TemplateOptionEnum>  = new Map([
    [BriefingBlockTypeEnum.IMAGE, TemplateOptionEnum.IMAGE],
    [BriefingBlockTypeEnum.TITLE, TemplateOptionEnum.TITLE],
    [BriefingBlockTypeEnum.TEXT, TemplateOptionEnum.TEXT],
    [BriefingBlockTypeEnum.DATE, TemplateOptionEnum.DATE],
    [BriefingBlockTypeEnum.TABLE_OF_CONTENT, TemplateOptionEnum.TABLE_OF_CONTENTS],
    [BriefingBlockTypeEnum.CURATED_MENTION_LIST, TemplateOptionEnum.CURATED_MENTION_LIST],
    [BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST, TemplateOptionEnum.AUTOMATIC_MENTION_LIST],
    [BriefingBlockTypeEnum.ANALYSIS, TemplateOptionEnum.ANALYSIS],
    [BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT, TemplateOptionEnum.ONE_COLUMN_LAYOUT],
    [BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT, TemplateOptionEnum.TWO_COLUMN_LAYOUT],
    [BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT, TemplateOptionEnum.THREE_COLUMN_LAYOUT],
    [BriefingBlockTypeEnum.CHART, TemplateOptionEnum.CHART],
    [BriefingBlockTypeEnum.COVERAGE_CURATOR, TemplateOptionEnum.COVERAGE_CURATOR],
    [BriefingBlockTypeEnum.LINK, TemplateOptionEnum.LINK],
    [BriefingBlockTypeEnum.DIVIDER, TemplateOptionEnum.DIVIDER]
]);

